<template>
    <div class="couponItem">
        <div class="couponHeader">
            <div class="topBtnBox">
            </div>
        </div>
        <div class="couponContent">
            <div class="leftBox">
                <div :class="props.coupon.couponType == 1 ? 'smallPrice' : 'promoteInfo'">
                    <text v-if="props.coupon.couponType == 1">￥{{ props.coupon.reduceAmount / 100 }}</text>
                    <text v-else>{{ props.coupon.discount / 10 }}折</text>
                </div>
                <text class="reachPrice" v-if="props.coupon.couponType == 1">
                    满{{ props.coupon.reachAmount/100 }}元使用
                </text>
            </div>
            <div class="rightBox">
                <div class="couponTitle">{{ props.coupon.title2 }}</div>
                <div class="couponExpireDate">有效期至{{ props.coupon.expireDate }}</div>
                <div class="productTypeLimit"> {{props.coupon.productType2 }}可用 </div>
            </div>
            <div class="couponSubInfo">
                <slot></slot>
            </div>
        </div>
        <div class="couponFooter">
        </div>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';
// 定义 props
const props = defineProps({
    coupon: {
        type: Object,
        required: true
    }
});
</script>

<style scoped>
/* 你可以在这里添加原有的样式 */

.couponItem {
    background-color: white;
    padding: 2vw 3vw;
    margin-bottom: 15px;
    border-radius: 2vw;
    width: 92vw;
    box-sizing: border-box;
}

.couponHeader {
    display: flex;
    justify-content: flex-end;
    height: 18px;
    position: relative;
}


.couponHeader .delBtn {
    position: absolute;
    top: 18px;
    right: 5px;
    z-index: 20;
}

.couponContent {
    display: flex;
    justify-content: flex-start;
    position: relative;
}

.couponContent .leftBox {
    width: 25vw;
    text-align: center;
}



.couponContent .leftBox .promoteInfo {

    font-weight: 600;
    font-size: 1rem;
    line-height: 8vw;
}

.couponContent .leftBox .promoteInfo {

    font-weight: 600;
    font-size: 1.4rem;
    line-height: 8vw;
}

.couponContent .leftBox .smallPrice {

    font-weight: 600;
    font-size: 1.4rem;
    line-height: 8vw;
}

.couponContent .leftBox .reachPrice {
    color: gray;
    font-size: 0.8rem;
}

.couponContent .rightBox {
    padding-left: 5vw;
    width: 50vw;
    position: relative;
}


.couponContent .couponSubInfo {
    color: rgb(165, 165, 165);

    position: absolute;
    width: 25vw;
    top: 30%;
    right: -7vw;
}

.productTypeLimit {
    color: gray;
    font-size: 0.8rem;
}

.couponContent .couponTitle {
    margin-top: 1vw;
}

.couponContent .rightBox .gateWay {
    color: rgb(165, 165, 165);
        font-size: 0.8rem;
 
}

.couponContent .rightBox .couponExpireDate {
    color: rgb(165, 165, 165);
     font-size: 0.8rem;
}


.couponItem .couponFooter {

    height: 25px;
    text-align: center;
}
</style>